import { DISCOUNT_FRESH_DAYS_COUNT } from 'config/constants';

export const calculateDiscountFreshness = (dateBegin: string) => {
  const discountStartDate = new Date(dateBegin);

  const freshnessEndingDate = discountStartDate.setDate(
    discountStartDate.getDate() + DISCOUNT_FRESH_DAYS_COUNT,
  );

  return freshnessEndingDate > Date.now();
};
